import { render, staticRenderFns } from "./fileComponent.vue?vue&type=template&id=32b68e47&scoped=true"
import script from "./fileComponent.vue?vue&type=script&lang=js"
export * from "./fileComponent.vue?vue&type=script&lang=js"
import style0 from "./fileComponent.vue?vue&type=style&index=0&id=32b68e47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b68e47",
  null
  
)

export default component.exports